import { Box, Container, Typography } from '@material-ui/core';
import { DynamicBitcoinRoutesConfig } from 'modules/dynamicBitcoin/Routes';
import { Button } from 'modules/uiKit/Button';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { useIsLGDown } from 'modules/themes/useTheme';
import { useHeaderLinksStyles } from '../HeaderLinks/HeaderLinksStyles';
import { Social } from '../Social';
import LineIcon from './assets/line.svg';
import LogoIcon from './assets/logoIcon.svg';
import { useFooterStyles } from './FooterStyles';

export const Footer = () => {
  const classes = useFooterStyles();
  const linksClasses = useHeaderLinksStyles();
  const isMobile = useIsLGDown();

  const renderedLinks = (
    <div className={classes.terms}>
      <Button
        component={NavLink}
        variant="text"
        className={classNames(linksClasses.link, classes.links)}
        to={DynamicBitcoinRoutesConfig.Index.path}
      >
        GENE
      </Button>
    </div>
  );

  return (
    <footer className={classes.root}>
      {isMobile ? (
        <Container maxWidth={false} className={classes.containerMobile}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Box>
              <Social />
            </Box>
            {renderedLinks}
          </Box>

          <Box className={classes.footerCenter}>
            <Box className={classes.logoBox}>
              <img src={LogoIcon} className={classes.footLogo} alt="" />
              <img src={LineIcon} className={classes.lines} alt="" />
            </Box>
            <Typography className={classes.copy}>
              Copyright © 2024 Powered by INS.EVM. All rights reserved
            </Typography>
          </Box>
        </Container>
      ) : (
        <Container maxWidth={false} className={classes.container}>
          {renderedLinks}
          <Box className={classes.footerCenter}>
            <img src={LogoIcon} alt="" />
            <Typography className={classes.copy}>
              Copyright © 2024 Powered by INS.EVM. All rights reserved
            </Typography>
          </Box>
          <Box>
            <Social />
          </Box>
        </Container>
      )}
    </footer>
  );
};
